// extracted by mini-css-extract-plugin
export default {"advertiesIcon":"AdvertiseBox_advertiesIcon__tL0Lx","advertiseContent":"AdvertiseBox_advertiseContent__CIZcx"};